import Face4OutlinedIcon from "@mui/icons-material/Face4Outlined";
import { useContext } from 'react';
import { db, timestamp } from '../../firebase/config';
import { client } from "../../hooks/Client";
import { v4 as uuid } from 'uuid';
import { DeccaContext } from "../../StateManagment/DeccaContext.js";
import newConversation from "../../agents/newConversation.js";
import { Auth } from '../../StateManagment/Auth.js';
import { useFirestoreOrderBy } from '../../firebase/useFirestore.js';

const AIProgressAnalysis = () => {
    // Context
        const [auth] = useContext(Auth)
        const {
            chatOpen,
            setChatOpen,
            setSelectedConversationID,
            setShowConversations,
            setSubject,
            } = useContext(DeccaContext);

    // Firestore
    const conversations = useFirestoreOrderBy('Conversations', 'Position', 'desc');

   // Function to handle analysis with Decca
    const analysisHandler = async () => {
        const conversationID = uuid();
        const title = `Algehele voortgangsanalyse`;
        const message = `<h2>Hallo ${auth.ForName}</h2><p>Zal ik een algemene analyse doen over jullie impact of wil je iets specifiekers weten?</p>`
        setSubject('GeneralProgressAnalysis');
        setChatOpen(chatOpen === false ? true : true);
        await newConversation(
            conversationID, 
            title, 
            message,
            conversations.length + 1,
            client,
            timestamp,
            uuid(),
            auth.ID,
            auth.ForName,
            db
        );
        setSelectedConversationID(conversationID);
        setShowConversations(false);
    }

  return (
     <div className='insights-main-type-container' >
        <div className="table-container dashboard-container">
            <h2>Voortgangsanalyse</h2>
            <p>Creëer een analyse van je impact strategie op basis van alle resultaten.</p>
            <div id='page-header-impact-ai-container' className="analysis-ai-container" onClick={analysisHandler}>
                <div id='page-header-impact-ai-inner-container'>
                    <Face4OutlinedIcon/>
                    <p>Analyseer met Decca</p>
                </div>
            </div>
        </div>
    </div> 
  )
}

export default AIProgressAnalysis